<div class="announcement-bar animate-fade-in">
    <!-- Gilded Label -->
    <div class="latest-label">
        <i class="fas fa-bell me-2"></i> LATEST
    </div>

    <!-- Scrolling Text Ticker -->
    <div class="marquee-container">
        <div class="marquee-content">
            <span class="marquee-item highlight-item">ADMISSION OPEN 2026-27</span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">ADMISSION OPEN 2026-27</span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">ADMISSION OPEN 2026-27</span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">ADMISSION OPEN 2026-27</span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">ADMISSION OPEN 2026-27</span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">ADMISSION OPEN 2026-27</span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">ADMISSION OPEN 2026-27</span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">ADMISSION OPEN 2026-27</span>
            <span class="separator-dot"></span>
            <!-- <span class="marquee-item highlight-item">
                We are Hiring for the Post of Principal. 
                <a [href]="pdfUrl" target="_blank" class="marquee-link">Download PDF</a> or 
                <a [href]="onlineFormUrl" target="_blank" class="marquee-link">Apply Online</a>
            </span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">
                We are Hiring for the Post of Principal. 
                <a [href]="pdfUrl" target="_blank" class="marquee-link">Download PDF</a> or 
                <a [href]="onlineFormUrl" target="_blank" class="marquee-link">Apply Online</a>
            </span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">
                We are Hiring for the Post of Principal. 
                <a [href]="pdfUrl" target="_blank" class="marquee-link">Download PDF</a> or 
                <a [href]="onlineFormUrl" target="_blank" class="marquee-link">Apply Online</a>
            </span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">
                We are Hiring for the Post of Principal. 
                <a [href]="pdfUrl" target="_blank" class="marquee-link">Download PDF</a> or 
                <a [href]="onlineFormUrl" target="_blank" class="marquee-link">Apply Online</a>
            </span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">
                We are Hiring for the Post of Principal. 
                <a [href]="pdfUrl" target="_blank" class="marquee-link">Download PDF</a> or 
                <a [href]="onlineFormUrl" target="_blank" class="marquee-link">Apply Online</a>
            </span>
            <span class="separator-dot"></span>
            <span class="marquee-item highlight-item">
                We are Hiring for the Post of Principal. 
                <a [href]="pdfUrl" target="_blank" class="marquee-link">Download PDF</a> or 
                <a [href]="onlineFormUrl" target="_blank" class="marquee-link">Apply Online</a>
            </span> -->
        </div>
    </div>

    <!-- Redirect Link -->
    <a href="#news" class="view-all-btn">
        View All <i class="fas fa-arrow-right ms-1"></i>
    </a>
</div>